import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { CustomLinkComponent, DynamicTag, Spinner } from 'msp-components'
import { useAccount } from 'msp-integrations'

import translations from './AccountOverviewData.constants'
import * as S from './AccountOverviewData.styles'

export type AccountOverviewDataProps = {
  className?: string
}

const AccountOverviewData = ({ className = '' }: AccountOverviewDataProps) => {
  const { formatDate, formatMessage } = useIntl()
  const { customer } = useAccount()
  const pageLink = '/account/my-data'
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions

  return (
    <div className={twMerge(S.MainWrapper, className)}>
      <DynamicTag
        componentTagName='Headline'
        tag='h3'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.headline)}
      </DynamicTag>
      {!customer.isInitialized && <Spinner />}
      {customer.isInitialized && (
        <div className={S.ListWrapper}>
          <div className={S.ListItem}>
            {customer.firstName} {customer.lastName}
          </div>
          <div className={S.ListItem}>
            {formatMessage(translations.birthDate, {
              date: customer.birthday
                ? formatDate(customer.birthday, dateFormattingOpts)
                : '-'
            })}
          </div>
          {customer.phoneMobile && (
            <div className={S.ListItem}>
              {formatMessage(translations.phoneMobile, {
                telephone: customer.phoneMobile
              })}
            </div>
          )}
          {customer.phoneHome && (
            <div className={S.ListItem}>
              {formatMessage(translations.phoneHome, {
                telephone: customer.phoneHome
              })}
            </div>
          )}
          {customer.phoneBusiness && (
            <div className={S.ListItem}>
              {formatMessage(translations.phoneBusiness, {
                telephone: customer.phoneBusiness
              })}
            </div>
          )}
          <div className={S.ListItem}>
            {formatMessage(translations.email, {
              email: customer.email
            })}
          </div>
        </div>
      )}
      <CustomLinkComponent href={pageLink} className={S.Link}>
        {formatMessage(translations.headline)}
      </CustomLinkComponent>
    </div>
  )
}

export default AccountOverviewData
